export const radioInputs = [
  {
    name: "calculatorType",
    label: "amountToBeReceived",
    type: "type1",
    value: 1,
  },
  {
    name: "calculatorType",
    label: "priceCharged",
    type: "type2",
    value: 2,
  },
];
